var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t("detail.navbar.map")))])]),_c('div',{staticClass:"col-12"},[_c('div',{ref:"mapContainer",staticClass:"google-map"})])])}
var staticRenderFns = []

export { render, staticRenderFns }